// Token anahtarlarının tek kaynağı (mobildeki TokenStorage'ın web karşılığı).
// Login, signup, logout ve auth interceptor token okuma/yazma işlemlerini
// buradan yapmalı. Backend Bearer-token modeli kullandığı için tokenlar
// localStorage'da saklanır ve Authorization header ile gönderilir.

import { resetSession } from './sessionManager';

const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';
const EMAIL_KEY = 'email';

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

export const getEmail = () => localStorage.getItem(EMAIL_KEY);

export const saveTokens = ({ access, refresh }) => {
  if (access) localStorage.setItem(ACCESS_TOKEN_KEY, access);
  if (refresh) localStorage.setItem(REFRESH_TOKEN_KEY, refresh);
  // Başarılı login/refresh sonrası zorunlu logout guard'ını yeniden kur.
  resetSession();
};

export const saveEmail = (email) => {
  if (email) localStorage.setItem(EMAIL_KEY, email);
};

// Yalnızca oturum anahtarlarını siler; dil tercihi (i18nextLng) gibi
// oturumdan bağımsız ayarlar korunur — localStorage.clear() kullanma.
export const clearTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(EMAIL_KEY);
};

export const hasSession = () => getRefreshToken() != null;
